import DescriptionListItem from "./DescriptionListItem";

export default DescriptionListItem